'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackBarrierUltimateSubscribe() {
    return (0, _track2.default)(_events.EVENT_BARRIER_ULTIMATE_SUBSCRIBE);
}

exports.default = trackBarrierUltimateSubscribe;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackBarrierUltimateSubscribe.js
// module id = 1757
// module chunks = 0